document.addEventListener("DOMContentLoaded", function () {
  function updateUpsellPrice(selectElement, priceElement, discountElement, imageElement) {
    var selectedOption = selectElement.selectedOptions[0];
    if (!selectedOption) return;

    var discount = selectedOption.getAttribute("data-discounted");
    var price = selectedOption.getAttribute("data-price");
    var image = selectedOption.getAttribute("data-image");

    if (imageElement && image) {
      imageElement.src = image;
    }

    if (discountElement && discount) {
      discountElement.textContent = discount;
    }

    if (priceElement) {
      if (price && price !== discount) {
        priceElement.textContent = price;
        priceElement.hidden = false;
      } else {
        priceElement.textContent = "";
        priceElement.hidden = true;
      }
    }
  }

  function initCartMixmatchUpsells() {
    document
      .querySelectorAll(".cart-mixmatch .cart-upsell:not([data-mixmatch-init])")
      .forEach(function (upsell) {
        upsell.setAttribute("data-mixmatch-init", "");

        var selectElement = upsell.querySelector(".cart-upsell__select");
        var priceElement = upsell.querySelector(".cart-upsell__price span.line-through");
        var discountElement = upsell.querySelector(
          ".cart-upsell__current-price"
        );
        var imageElement = upsell.querySelector(".cart-upsell__image img");

        if (!selectElement) return;

        selectElement.addEventListener("change", function () {
          updateUpsellPrice(selectElement, priceElement, discountElement, imageElement);
        });

        updateUpsellPrice(selectElement, priceElement, discountElement, imageElement);
      });
  }

  function hasRecommendationSlides(node) {
    return !!(node && node.querySelector(".splide__slide"));
  }

  async function fetchRecommendationSection(url) {
    if (!url) return null;

    try {
      var response = await fetch(url, {
        headers: { "Cache-Control": "no-cache" },
      });
      if (!response.ok) return null;

      var text = await response.text();
      var doc = new DOMParser().parseFromString(text, "text/html");
      var content = doc.querySelector("[data-cart-add-save]");

      if (!hasRecommendationSlides(content)) return null;
      return content;
    } catch (error) {
      console.error("Cart Add & Save recommendations failed", error);
      return null;
    }
  }

  async function loadCartAddSaveRecommendations(root) {
    if (!root || root.dataset.loading === "true") return false;
    root.dataset.loading = "true";

    var url = root.getAttribute("data-related-url");
    var content = await fetchRecommendationSection(url);

    if (content) {
      root.replaceWith(content);
      return true;
    }

    root.remove();
    return false;
  }

  async function refreshCartAddSave() {
    var root = document.querySelector("[data-cart-add-save-root]");
    if (root) {
      await loadCartAddSaveRecommendations(root);
    }

    initCartMixmatchUpsells();

    if (
      Shopify?.cartUpsellsApp &&
      document.querySelector(".cart-mixmatch-container")
    ) {
      Shopify.cartUpsellsApp.init({ sliderSelector: ".cart-upsells" });
    }
  }

  window.theme = window.theme || {};
  window.theme.cart = window.theme.cart || {};
  window.theme.cart.refreshAddSave = refreshCartAddSave;

  initCartMixmatchUpsells();
  refreshCartAddSave();

  new MutationObserver(function () {
    initCartMixmatchUpsells();
  }).observe(document.body, {
    childList: true,
    subtree: true,
  });
});
